import { inventorySlotQueryKeys as e } from "./useInventorySlotQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { inventorySlotsApi as r } from "@maat/api-main";
//#region src/inventorySlots/useOverrideSlotMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ kind: e, inventoryId: t, slotId: n, data: i }) => r.overrideSlot(e, t, n, i),
		onSuccess: (t, { kind: n, inventoryId: r }) => {
			i.invalidateQueries({ queryKey: e.host(n, r) });
		}
	});
};
//#endregion
export { i as useOverrideSlotMutation };
